import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Left = () => {
    return (
        <div className="bg-nude">
            <div className="container">
                <div className="wrapper w-clearfix wf-section">
                    <div className="section-left">
                        <div className="content content-main">
                            <div className="header-mask">
                                <h1 className="header swipe-up">Mile Ristov</h1>
                            </div>
                            <div className="description-mask">
                                <p className="description">
                                    Front-End Developer
                                </p>
                            </div>
                            <div className="description-mask">
                                <p className="description">
                                    I'm Mile Ristov, a front-end developer
                                    passionate about crafting user-friendly web
                                    applications. I'm excited to collaborate and
                                    work together to create innovative solutions
                                    that exceed expectations.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="section-right">
                        <div className="nav">
                            <motion.div
                                className="nav-item"
                                initial={{
                                    x: 500,
                                    opacity: 0,
                                }}
                                animate={{
                                    x: 0,
                                    opacity: 1,
                                }}
                                transition={{
                                    duration: 1,
                                }}
                            >
                                <Link to="/work" className="nav-link">
                                    Work
                                </Link>
                            </motion.div>
                            <motion.div
                                className="nav-item"
                                initial={{
                                    x: 500,
                                    opacity: 0,
                                }}
                                animate={{
                                    x: 0,
                                    opacity: 1,
                                }}
                                transition={{
                                    duration: 1.4,
                                }}
                            >
                                <Link to="/about" className="nav-link">
                                    About
                                </Link>
                            </motion.div>
                            <motion.div
                                className="nav-item"
                                initial={{
                                    x: 500,
                                    opacity: 0,
                                }}
                                animate={{
                                    x: 0,
                                    opacity: 1,
                                }}
                                transition={{
                                    duration: 1.8,
                                }}
                            >
                                <Link to="/contact" className="nav-link">
                                    Contact
                                </Link>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Left;
